import axios, { AxiosRequestConfig } from "axios";

export default async (config: AxiosRequestConfig) => {
    try
    {
        const response = await axios?.(config)
        return response.data
    } catch(e)
    {
        throw e
    }
}
